import React from 'react'
import Tooltip from './Tooltip'
import { FIELD_TOOLTIPS } from '../utils/fieldTooltips'

const MIN_REASON_DETAIL_LEN = 20

const reasonCodeLabels = {
  exclusion_moratoria: 'Exclusion moratoria',
  ajuste_autonomo_mackler: 'Ajuste autonomo Mackler',
  correccion_ocr: 'Correccion OCR',
  ajuste_manual_perito: 'Ajuste manual perito',
}

const reasonCodeStyles = {
  exclusion_moratoria: 'border-rose-300/50 bg-rose-500/20 text-rose-100',
  ajuste_autonomo_mackler: 'border-fuchsia-300/50 bg-fuchsia-500/20 text-fuchsia-100',
  correccion_ocr: 'border-cyan-300/50 bg-cyan-500/20 text-cyan-100',
  ajuste_manual_perito: 'border-amber-300/50 bg-amber-500/20 text-amber-100',
}

export default function MutationAuditAccordion({
  mutationsLog,
  mutationsIntegrityHash,
  mutationsQualityAudit,
  copyHashFeedback,
  setCopyHashFeedback,
  showMutationsAccordion,
  setShowMutationsAccordion,
  asistidoMode,
}) {
  return (
    <div className="mt-3 rounded-lg border border-white/15 bg-slate-950/40 p-3">
      {mutationsQualityAudit?.hasWeakJustifications && (
        <div className="mb-3 rounded-lg border border-rose-300/45 bg-rose-500/15 px-3 py-2 text-xs text-rose-100">
          Bloqueo legal activo: {mutationsQualityAudit.invalidCount} justificaciones no cumplen el estándar mínimo de {MIN_REASON_DETAIL_LEN} caracteres descriptivos.
        </div>
      )}
      <button
        type="button"
        onClick={() => setShowMutationsAccordion((p) => !p)}
        className="flex w-full items-center justify-between text-left"
      >
        <span className="text-xs font-semibold text-slate-100">Historial de Ajustes Periciales del Expediente (Trazabilidad Inmutable)</span>
        <span className="rounded-full border border-white/20 bg-white/10 px-2 py-0.5 text-[11px] text-slate-200">{mutationsLog.length}</span>
      </button>
      <div className="mt-2 flex flex-wrap items-center gap-2 text-[11px] text-slate-300">
        <span className="rounded border border-white/15 bg-black/20 px-2 py-1">{asistidoMode ? <Tooltip text={FIELD_TOOLTIPS.mutationsIntegrityHash.tooltipText}>Hash:</Tooltip> : 'Hash:'} {mutationsIntegrityHash ? `${mutationsIntegrityHash.slice(0, 18)}...` : 'calculando...'}</span>
        <button
          type="button"
          onClick={async () => {
            if (!mutationsIntegrityHash) return
            try {
              await navigator.clipboard.writeText(mutationsIntegrityHash)
              setCopyHashFeedback('Hash copiado')
            } catch {
              setCopyHashFeedback('No se pudo copiar')
            }
            setTimeout(() => setCopyHashFeedback(''), 1800)
          }}
          className="rounded border border-white/25 bg-white/10 px-2 py-1 font-semibold text-white"
        >
          Copiar hash
        </button>
        {copyHashFeedback && <span className="text-emerald-300">{copyHashFeedback}</span>}
      </div>
      {showMutationsAccordion && (
        <div className="mt-3 overflow-x-auto">
          {mutationsLog.length === 0 ? (
            <p className="text-xs text-slate-300">Sin mutaciones registradas en este expediente.</p>
          ) : (
            <table className="min-w-full text-[11px] text-slate-200">
              <thead>
                <tr className="text-left text-slate-400">
                  <th className="px-2 py-1">Fecha</th>
                  <th className="px-2 py-1">Periodo</th>
                  <th className="px-2 py-1">Campo</th>
                  <th className="px-2 py-1">Cambio</th>
                  <th className="px-2 py-1">Motivo</th>
                </tr>
              </thead>
              <tbody>
                {mutationsLog.slice().reverse().map((m) => (
                  <tr key={m.id} className="border-t border-white/10 align-top">
                    <td className="px-2 py-1">{new Date(m.timestamp || Date.now()).toLocaleString('es-AR')}</td>
                    <td className="px-2 py-1">{m.periodo || '-'}</td>
                    <td className="px-2 py-1">{m.field || '-'}</td>
                    <td className="px-2 py-1">{String(m.originalValue)} {'->'} {String(m.newValue)}</td>
                    <td className="px-2 py-1">
                      <span className={`inline-flex rounded-full border px-2 py-0.5 ${reasonCodeStyles[m.reasonCode] || 'border-white/20 bg-white/10 text-slate-100'}`}>
                        {reasonCodeLabels[m.reasonCode] || m.reasonCode || 'Motivo'}
                      </span>
                      {m.reasonDetail && <p className="mt-1 text-slate-300">{m.reasonDetail}</p>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  )
}
